import { CreativeObjectType } from "@/model/creative.js"
import { isLegacy, createLegacyCustomName } from "./legacy"

export const getFileName = ({
  data,
  assetCategory,
}: {
  data: CreativeObjectType
  assetCategory?: { display_name: string }
}) => {
  // legacy check
  const isLegacyFile = isLegacy(new Date(data.created_at), data.tag_data)
  if (isLegacyFile) {
    return createLegacyCustomName(
      data.creative_id,
      data.tag_data,
      data.file_data.s3_filename,
      assetCategory ? assetCategory.display_name : "",
    )
  }
  return data?.file_data?.filename
}
